import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleLogout: () => void;
}

export default function LogoutModal({
  open,
  setOpen,
  handleLogout,
}: ModalProps) {
  return (
    <Modal
      className="modal addReply_modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title" style={{ justifyContent: "center" }}>
            <h2>  Are you sure you want to logout?</h2>

          </div>



          <div className="footer_btn_flex">
            <Button className="btn btn_grey" onClick={() => setOpen(false)}>
              No
            </Button>

            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpen(false);
                handleLogout();
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
